<section class="add-task-wrapper">
  <h2>Add Task</h2>
  <section class="form-container">
    <div class="form">
      <div class="addTaskForm">
        <div class="title-field">
          <label for="titleInput">Title<span class="warning">*</span></label>
          <div class="input-wrapper" [ngClass]="{'error': !title && titleTouched}">
            <input id="titleInput" [(ngModel)]="title" type="text" placeholder="Enter a title"
              (blur)="titleTouched = true" />
          </div>
          <div class="input-hint">
            @if (!title && titleTouched) {
            <span role="alert">Please enter a title</span>}
          </div>
        </div>
        <div class="description-field">
          <label for="description">Description</label>
          <textarea [(ngModel)]="description" rows="5" name="description" id="description"
            placeholder="Enter a Description"></textarea>
        </div>

        <div class="date-field">
          <label for="dateInput">Due date<span class="warning">*</span></label>
          <div class="date-input-container input-wrapper" [ngClass]="{'error': !date && dateTouched}">
            <input id="dateInput" matInput [matDatepicker]="picker" [(ngModel)]="date" [min]="minDate"
              placeholder="dd/mm/yyyy" (blur)="dateTouched = true" (focus)="picker.open()" />
            <mat-datepicker-toggle matSuffix [for]="picker">
              <img matDatepickerToggleIcon src="/assets/images/board/calender.svg" alt="calender icon" />
            </mat-datepicker-toggle>
            <mat-datepicker id="test-datepicker" #picker></mat-datepicker>
          </div>
          <div class="input-hint">
            @if (!date && dateTouched) {
            <span role="alert">Please enter a valid date</span>
            }
          </div>
        </div>
      </div>

      <div class="border"></div>

      <div class="taskOptions">
        <div class="prio-wrapper">
          <p>Priority</p>
          <div class="prio-btn-container">
            <button class="urgent" [ngClass]="{ active: selectedPrio === 'urgent' }" (click)="selectPrio('urgent')">
              Urgent <img src="/assets/images/board/prio-urgent.svg" alt="" />
            </button>
            <button class="medium" [ngClass]="{ active: selectedPrio === 'medium' }" (click)="selectPrio('medium')">
              Medium <img src="/assets/images/board/prio-medium.svg" alt="" />
            </button>
            <button class="low" [ngClass]="{ active: selectedPrio == 'low' }" (click)="selectPrio('low')">
              Low <img src="/assets/images/board/prio-low.svg" alt="" />
            </button>
          </div>
        </div>

        <div class="assignedTo-wrapper">
          <p>Assigned to</p>
          <div class="custom-select" tabindex="0" (blur)="contactDropDownOpen = false">
            <div class="selected" (click)="contactDropDownOpen = !contactDropDownOpen">
              <span>Select contacts to assign</span>
              <img src="/assets/images/board/arrow_drop_down.svg" alt="" />
            </div>
            @if (contactDropDownOpen) {
            <div class="dropdown" (mousedown)="$event.preventDefault()">
              @for (group of contactlist.getGroupedContacts(); track
              group.letter) {
              <div class="group">
                @for (contact of group.contacts; track contact.id) {
                <label class="dropdown-option" [class.selected]="isSelected(contact)" (click)="toggleContact(contact)">
                  <span class="contact-initials" [style.background]="
                      getColorForLetter(contact.firstName.charAt(0))
                    ">
                    {{ contact.firstName.charAt(0).toUpperCase()
                    }}{{ contact.lastName.charAt(0).toUpperCase() }}
                  </span>
                  <span class="contact-name">
                    {{ contact.firstName }} {{ contact.lastName }}
                  </span>
                  <span class="checkbox-container" (click)="$event.stopPropagation()">
                    <input type="checkbox" [checked]="isSelected(contact)" (change)="toggleContact(contact)"
                      id="contact-{{ contact.id }}" />
                    <label for="contact-{{ contact.id }}" class="custom-checkbox"></label>
                  </span>
                </label>
                }
              </div>
              }
            </div>
            }
          </div>
          @if (selectedContacts.length > 0) {
          <div class="selected-contacts-initials">
            @for (contact of displayedContacts; track contact.id) {
            <span class="contact-initials" [style.background]="
                getColorForLetter(contact.firstName.charAt(0))
              ">
              {{ contact.firstName.charAt(0).toUpperCase()
              }}{{ contact.lastName.charAt(0).toUpperCase() }}
            </span>
            } @if (hasExtraContacts) {
            <span class="contact-initials extra-count">
              +{{ remainingCount }}
            </span>
            }
          </div>
          }
        </div>

        <div class="category-wrapper">
          <p>Category<span class="warning">*</span></p>
          <div class="custom-select input-wrapper" [ngClass]="{'error': !category && categoryTouched}" tabindex="0"
            (blur)="onCategoryBlur()">
            <div class="selected" (click)="categoryDropDownOpen = !categoryDropDownOpen">
              @if (!category) {
              <span>Select task category</span>
              } @if (category) {
              <span>{{ category }}</span>
              }
              <img id="img-drop-down" src="/assets/images/board/arrow_drop_down.svg" alt="" />
            </div>
            @if (categoryDropDownOpen) {
            <div class="dropdown" (mousedown)="$event.preventDefault()">
              <div (click)="
                  category = 'Technical Task'; categoryDropDownOpen = false
                " class="dropdown-option">
                Technical Task
              </div>
              <div (click)="category = 'User Story'; categoryDropDownOpen = false" class="dropdown-option">
                User Story
              </div>
            </div>
            }
          </div>
          <div class="input-hint">
            @if (!category && categoryTouched) {
            <span role="alert">Please enter a valid category</span>}
          </div>
        </div>

        <div class="subtasks-wrapper">
          <label for="subtasks">Subtasks</label>
          <div class="input-wrapper">
            <input [(ngModel)]="newSubtask" id="subtasks" type="text" placeholder="Add new subtask"
              (keyup.enter)="addSubtask()" (focus)="showSubtaskControls()" (blur)="onSubtaskBlur()" #subtaskInput />
            <img src="/assets/images/board/add.svg" [class.hide]="isSubtaskActive" alt=""
              (click)="showSubtaskControls()" />
            <div class="focus-subtasks-input" [class.show]="isSubtaskActive">
              <button class="icon-check-button" (click)="addSubtask()">
                <img class="check" src="/assets/images/board/check.svg" alt="check button" />
              </button>
              <div class="border"></div>
              <button class="icon-close-button" (click)="clearSubtaskInput()">
                <img class="close" src="/assets/images/board/close.svg" alt="close button" />
              </button>
            </div>
          </div>
          @if (subtasks.length > 0) {
          <ul class="subtasks-list">
            @for (subtask of subtasks; track subtask; let i = $index) {
            <li class="subtask-item" (dblclick)="editSubtask(i)">
              @if (editingSubtaskIndex === i) {
              <input type="text" [(ngModel)]="editingSubtaskValue" (keydown)="onSubtaskKeydown($event)"
                (blur)="saveEditedSubtask()" class="subtask-edit-input" #editInput />
              } @else {
              <span>{{ subtask }}</span>
              }
              <div class="subtask-single-item-icons">
                @if (editingSubtaskIndex === i) {
                <img src="/assets/images/board/check.svg" alt="save subtask" (click)="saveEditedSubtask()" />
                <div class="border"></div>
                <img src="/assets/images/board/close.svg" alt="cancel edit" (click)="cancelEditSubtask()" />
                } @else {
                <img src="/assets/images/board/edit.svg" alt="edit subtask" (click)="editSubtask(i)" />
                <div class="border"></div>
                <img src="/assets/images/board/delete.svg" alt="delete subtask" (click)="removeSubtask(i)" />
                }
              </div>
            </li>
            }
          </ul>
          }
        </div>
      </div>
    </div>
    <p class="requierd-text"><span class="warning">*</span>This field is requierd</p>
  </section>
</section>

<div class="button-container" [class.fixed-position]="useFixedPosition" [class.flex-position]="!useFixedPosition"
  [style]="useFixedPosition ? buttonStyles : null">
  <button (click)="clearForm()" class="button-white-border">
    <span>Clear</span>
    <img src="/assets/images/icons/icon-cancel.svg" alt="clear task" />
  </button>
  <button (click)="addTaskToDBViaTemplateClick()" class="button-blue" [disabled]="!title || !date || !category">
    <span>Create Task</span>
    <img src="/assets/images/icons/icon-check.svg" alt="create task" />
  </button>
</div>
